/**
 * Created by Ning Jiang on 2021-05-18.
 */

export interface ISymbolsConfig {
    [symName:string]:{
        states:TombstoneRipSymbolState[];
        reels?:number[]; // do we need this?
        highSymbol?:boolean; // For which layer this symbol will be added.
        isSpecial?:boolean; // For is the symbol can be used for fill up the reel randomly.
        stackedTotalNum?:number[] | number; // Can be same number for all reels, or different each reel.
        symbolHeightFactor?:number;
    };
}

export enum TombstoneRipSymbolState {
    INIT = "init",
    NORMAL = "normal",
    SPIN = "spin",
    LANDING = "landing",
    NO_WIN = "noWin",
    NO_WIN_HINT = "noWinHint",
}

export class TombstoneRipSymbolConfig {

    public static SYMBOLS_DEFAULT_STATES:TombstoneRipSymbolState[] = [
        TombstoneRipSymbolState.INIT,
        TombstoneRipSymbolState.NORMAL,
        TombstoneRipSymbolState.SPIN,
        TombstoneRipSymbolState.LANDING,
        TombstoneRipSymbolState.NO_WIN,
        TombstoneRipSymbolState.NO_WIN_HINT
    ];

    public static SYMBOLS:ISymbolsConfig = {
        "L1" : {states : TombstoneRipSymbolConfig.SYMBOLS_DEFAULT_STATES},
        "L2" : {states : TombstoneRipSymbolConfig.SYMBOLS_DEFAULT_STATES},
        "L3" : {states : TombstoneRipSymbolConfig.SYMBOLS_DEFAULT_STATES},
        "L4" : {states : TombstoneRipSymbolConfig.SYMBOLS_DEFAULT_STATES},
        "L5" : {states : TombstoneRipSymbolConfig.SYMBOLS_DEFAULT_STATES},
        "M1" : {
            states : TombstoneRipSymbolConfig.SYMBOLS_DEFAULT_STATES,
            reels : [0, 1, 2, 3]
        },
        "M2" : {
            states : TombstoneRipSymbolConfig.SYMBOLS_DEFAULT_STATES,
            reels : [0, 1, 2, 3]
        },
        "M3" : {
            states : TombstoneRipSymbolConfig.SYMBOLS_DEFAULT_STATES,
            reels : [0, 1, 2, 3]
        },
        "M4" : {
            states : TombstoneRipSymbolConfig.SYMBOLS_DEFAULT_STATES,
            reels : [0, 1, 2, 3]
        },
        "M5" : {
            states : TombstoneRipSymbolConfig.SYMBOLS_DEFAULT_STATES,
            reels : [0, 1, 2, 3]
        },
        "M1D" : {
            states : TombstoneRipSymbolConfig.SYMBOLS_DEFAULT_STATES,
            reels : [4],
            symbolHeightFactor : 2
        },
        "M2D" : {
            states : TombstoneRipSymbolConfig.SYMBOLS_DEFAULT_STATES,
            reels : [4],
            symbolHeightFactor : 2
        },
        "M3D" : {
            states : TombstoneRipSymbolConfig.SYMBOLS_DEFAULT_STATES,
            reels : [4],
            symbolHeightFactor : 2
        },
        "M4D" : {
            states : TombstoneRipSymbolConfig.SYMBOLS_DEFAULT_STATES,
            reels : [4],
            symbolHeightFactor : 2
        },
        "M5D" : {
            states : TombstoneRipSymbolConfig.SYMBOLS_DEFAULT_STATES,
            reels : [4],
            symbolHeightFactor : 2
        },
        "S1" : {
            states : TombstoneRipSymbolConfig.SYMBOLS_DEFAULT_STATES,
            isSpecial : true,
            highSymbol : true,
            reels : [1, 2, 3]
        },
        "S2" : {
            states : TombstoneRipSymbolConfig.SYMBOLS_DEFAULT_STATES,
            isSpecial : true,
            highSymbol : true,
            reels : [4],
            symbolHeightFactor : 2
        },
        "W0" : {
            states : TombstoneRipSymbolConfig.SYMBOLS_DEFAULT_STATES,
            isSpecial : true,
            highSymbol : true,
            reels : [1, 2, 3]
        },
        "W0D" : {
            states : TombstoneRipSymbolConfig.SYMBOLS_DEFAULT_STATES,
            isSpecial : true,
            highSymbol : true,
            reels : [4],
            symbolHeightFactor : 2
        },
        "W1" : {
            states : TombstoneRipSymbolConfig.SYMBOLS_DEFAULT_STATES,
            isSpecial : true,
            highSymbol : true,
            stackedTotalNum : 3,
            reels : [1]
        },
        "W2" : {
            states : TombstoneRipSymbolConfig.SYMBOLS_DEFAULT_STATES,
            isSpecial : true,
            highSymbol : true,
            stackedTotalNum : 3,
            reels : [2],
        },
        "W3" : {
            states : TombstoneRipSymbolConfig.SYMBOLS_DEFAULT_STATES,
            isSpecial : true,
            highSymbol : true,
            stackedTotalNum : 3,
            reels : [3],
        },
        "WRS" : {
            states : TombstoneRipSymbolConfig.SYMBOLS_DEFAULT_STATES,
            isSpecial : true,
            highSymbol : true,
            reels : [1, 2, 3]
        },
        "WXS" : {
            states : TombstoneRipSymbolConfig.SYMBOLS_DEFAULT_STATES,
            isSpecial : true,
            highSymbol : true,
            reels : [4],
            symbolHeightFactor : 2
        },
    };
}